import {
  type BooleanFilterTranslation,
  type DropdownFilterTranslation,
} from '@/components/filtering/filter-set/types'

import { type OrderMenuType, type OrderStatus, type OrderType } from '../types'

interface OrdersTranslations {
  filters2: Record<
    string,
    BooleanFilterTranslation | DropdownFilterTranslation | string
  >
  type: Record<OrderType, string>
  status: Record<OrderStatus, string>
  menuType: Record<OrderMenuType, string>
}

const typeOptions: Record<OrderType, string> = {
  delivery: 'Delivery',
  pickup: 'Pickup',
  store: 'Store',
}

const statusOptions: Record<OrderStatus, string> = {
  cancelled: 'Cancelled',
  claimed: 'Claimed',
  completed: 'Completed',
  unclaimed: 'Unclaimed',
  unconfirmed: 'Unconfirmed',
  voided: 'Voided',
}

const menuTypeOptions: Record<OrderMenuType, string> = {
  catering: 'Catering',
  olo: 'Online ordering',
}

export const ordersEn: OrdersTranslations = {
  filters2: {
    menuType: {
      label: 'Menu',
      options: menuTypeOptions,
    },
    status: {
      label: 'Status',
      options: statusOptions,
    },
    type: {
      label: 'Type',
      options: typeOptions,
    },
  },
  menuType: menuTypeOptions,
  status: statusOptions,
  type: typeOptions,
}
